import React, { Dispatch, SetStateAction } from 'react';

import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { FeatureSelectorType } from '@components/feature-selector/Types';
import { RetailerKpiOption, SaleType } from '@models/Products';
import { FactRevenue, ShareType, SubSection } from '@utils/pageConfig/Types';
import { ExportPerformanceBySegmentResp } from './Types';
import CombinedMultiChartView from '@components/combined-multi-chart-view/CombinedMultiChartView';
import PerformanceAnalysisMarketCard from '@components/performance-analysis-market-card/PerformanceAnalysisMarketCard';
import PerformanceAnalysisRetailerCard from '@components/performance-analysis-retailer-card/PerformanceAnalysisRetailerCard';
import { modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue } from '@utils/TotalUtils';

interface Props {
  data: ExportPerformanceBySegmentResp;
  selectedPeriodicity: Periodicity;
  factRevenue: FactRevenue;
  loadingLineChart: boolean;
  selectedShareType: ShareType;
  onChangeSelectedShareType: any;
  featureHandler: () => void;
  featureSelectorType: FeatureSelectorType;
  noResultHandler: () => void;
  volume: string;
  selectedRetailerOption: RetailerKpiOption;
  setSelectedRetailerOption: Dispatch<SetStateAction<RetailerKpiOption>>;
  selectedLineChartSaleType: SaleType;
  setSelectedLineChartSaleType: Dispatch<SetStateAction<SaleType>>;
  noPeriodExistForMulticountry?: boolean;
  isExplorePage?: boolean;
  trackingTitle: string;
  subSectionForAmplitudeTracking: SubSection;
}

const PerformanceAnalysisLineChartView: React.FC<Props> = ({
  data,
  selectedPeriodicity,
  factRevenue,
  loadingLineChart,
  selectedShareType,
  onChangeSelectedShareType,
  featureSelectorType,
  featureHandler,
  noResultHandler,
  volume,
  noPeriodExistForMulticountry,
  selectedRetailerOption,
  setSelectedRetailerOption,
  selectedLineChartSaleType,
  setSelectedLineChartSaleType,
  isExplorePage,
  trackingTitle,
  subSectionForAmplitudeTracking,
}) => {
  return (
    <CombinedMultiChartView
      data={data}
      transformData={modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue}
      loading={loadingLineChart}
      selectedPeriodicity={selectedPeriodicity}
      factRevenue={factRevenue}
      selectedShareType={selectedShareType}
      onChangeSelectedShareType={onChangeSelectedShareType}
      featureSelectorType={featureSelectorType}
      featureHandler={featureHandler}
      noResultHandler={noResultHandler}
      volume={volume}
      selectedRetailerOption={selectedRetailerOption}
      setSelectedRetailerOption={setSelectedRetailerOption}
      saleType={selectedLineChartSaleType}
      setSaleType={setSelectedLineChartSaleType}
      noPeriodExistForMulticountry={noPeriodExistForMulticountry}
      isExplorePage={isExplorePage}
      trackingTitle={trackingTitle}
      CardMarket={PerformanceAnalysisMarketCard}
      CardRetailer={PerformanceAnalysisRetailerCard}
      marketSaleTypeProp="selectedLineChartSaleType"
      retailerSaleTypeProp="selectedLineChartSaleType"
      subSectionForAmplitudeTracking={subSectionForAmplitudeTracking}
    />
  );
};

export default PerformanceAnalysisLineChartView;
